module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic1.575a571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic1.png
// module id = 474
// module chunks = 1